export default __webpack_public_path__ + "static/4)ZeroFunOption1-0e49133df73719c44e266c48c6c92fcf.mp3";